import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { PARAMS } from '@/store/modules/account/reclamations/state.js'

// TODO: когда будут большие изменения на странице рекламаций, то нужно удалить этот бесполезный миксин, вместо него лучше завести общую компоненту страницы рекламаций 
export default {
  components: {
    Tabs: () => import('@/pages/account/components/Tabs'),
    Journal: () => import('@/pages/account/reclamations/components/journal/Journal'),
  },

  data: () => ({
    tabActive: 'work',
    tabs: [
      {
        name: 'Рекламации в работе',
        path: 'work',
      },
      {
        name: 'Архив рекламаций',
        path: 'archived',
      },
    ],
    load: false,
    filters: null,
  }),

  computed: {
    ...mapState({
      params: state => state.account.reclamations.params,
      statuses: state => state.account.reclamations.statuses,
    }),

    ...mapGetters('account/reclamations', [
      'isArchive',
      'isDealers',
    ]),
  },

  created() {
    this.filters = {
      ...PARAMS,
      ...this.$route.query
    }

    this.fetchStatuses();

    if (this.isDealers) {
      this.fetchsDealers();
    }

    if (this.isArchive) {
      this.tabActive = this.tabs[1].path;
    }

    const query = this.$route.query;

    if (localStorage.per_page) {
      this.updateParams({
        key: 'per_page',
        val: localStorage.per_page,
      });
    }

    for (let key in query) {
      if(this.params[key] !== undefined) {
        this.updateParams({
          key,
          val: query[key],
        });
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.load = true;
    })
  },

  methods: {
    ...mapActions('account/reclamations', [
      'loadStatuses',
    ]),

    ...mapActions('account/dealers', [
      'setDealers',
    ]),

    ...mapMutations('account/reclamations', [
      'updateParams',
      'clearParams',
    ]),

    async fetchStatuses() {
      await this.loadStatuses()
    },

    async fetchsDealers() {
      await this.setDealers(true)
    },

    $_reclamations_updateTab(path) {
      this.load = false;
      this.tabActive = path;

      this.$nextTick(() => {
        this.load = true;
      })
    },

    $_reclamations_clearParams() {
      this.clearParams();
    },
  }
};
